<template>
<div class="ml-10 mr-10">
  <el-row>
      <el-col :span="24" class="m-10">
          <h3>Payment Summary - Oustanding Balance</h3>
          <span class="description"
              >Manage your outstanding registration balance.</span
          >
      </el-col>
  </el-row>
  <el-card>
    <el-card-body class="d-flex justify-between align-items-center responsive-card-body">
      <div class="info-container">
        <div class="general-info" style="flex: 2; ">
          <h4>Registration Details</h4>
          <div class="detail-item">
            <span class="label">ID:</span> <span class="value">{{ rego._id }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Type:</span> <span class="value">Event</span>
          </div>
          <div class="detail-item">
            <span class="label">Name:</span> <span class="value">{{ rego.eventName }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Date:</span> <span class="value">{{ dateFormatter(false, false, rego.createdAt) }}</span>
          </div>
        </div>
        <div class="payment-info" style="flex: 2; ">
          <h4>Payment Details</h4>
          <div class="detail-item">
            <span class="label">Total:</span> <span class="value">{{ parsePrice(totalPrice) }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Amount Paid:</span> <span class="value">{{ parsePrice(amountPaid)}}</span>
          </div>
          <div class="detail-item">
            <span class="label">Outstanding:</span> <span class="value">{{ parsePrice(outstanding) }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Due Date:</span> <span class="value">{{ dateFormatter(false, false, rego.payAfterDueDate) }}</span>
          </div>
        </div>
      </div>
      <div class="progress-container mt-1">
        <!-- <el-progress type="circle" :percentage="getProgress" :stroke-width="10" color="blue"></el-progress> -->
        <el-progress type="dashboard" :status="outstanding === 0 ? 'success' : null" :percentage="paymentPercentage" ></el-progress>
        <h4 v-if="outstanding === 0" class="description">All paid up!</h4>
        <h4 v-else class="description">{{parsePrice(outstanding)}} Outstanding</h4>
      </div>
    </el-card-body>
  </el-card>

  <el-divider v-if="registration && registration.payAfter"></el-divider>
    <el-card class="mt-10">
    <div class=" " v-if="outstanding > 0">
      <el-row :gutter="20">
      <el-form ref="form" :model="payment" :rules="rules" class="payment-form">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="payment-section">
        <h2>Payment Details</h2>
        <el-price-input v-model="payToday" :min="minPayment" :max="outstanding" :key="key" />
        <div class="pay-today">
          Pay Today: <strong>{{ parsePrice(payTodayTotal) }}</strong>
          <!-- <span class="transaction-fee">*Includes a 4% transaction fee</span> -->
        </div>
        <div class="transaction-fee">*Includes a {{ transactionFee }}% transaction fee</div>
        <div class="credit-card-section">
          <h2>Credit Card Details</h2>
          <credit-card v-model="payment.card" ref="card" :width="300"/>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="billing-section">
        <h2>Billing Address</h2>
        <el-form-item label="Address Line 1">
                  <el-input v-model="payment.billingAddress.addressLine1" placeholder="Type here..." />
                </el-form-item>
                <el-form-item label="Address Line 2">
                  <el-input v-model="payment.billingAddress.addressLine2" placeholder="Type here..." />
                </el-form-item>
                <el-form-item label="City/Suburb">
                  <el-input v-model="payment.billingAddress.suburb" placeholder="Type here..." />
                </el-form-item>
                <el-form-item label="State">
                  <el-input v-model="payment.billingAddress.state" placeholder="Type here..." />
                </el-form-item>
                <el-form-item label="Postcode">
                  <el-input v-model="payment.billingAddress.postcode" placeholder="Type here..." />
                </el-form-item>
                <el-form-item class="d-flex flex-column align-items-start" label="Country">
                  <el-select filterable remote reserve-keyword v-model="payment.billingAddress.country" :remote-method="searchCountry" placeholder="Select">
                    <el-option v-for="item in countryItems" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
      </el-col>
      </el-form>
    </el-row>
    </div>
    <el-divider></el-divider>
      <el-row>
        <el-col :span="24">
          <!-- 2 buttons, one for cancel, one for make payment -->
          <div class="make-payment-btn">
            <el-button type="secondary" @click="goBack">Cancel</el-button>
            <el-button type="primary" @click="submitPayment">Make Payment</el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import _ from 'lodash';
import { errormsg, countries } from '@/utils/constants';

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.input_option };
const pin = new Pin.Api(process.env.VUE_APP_PIN_PK, process.env.VUE_APP_PIN_ENV);
export default {
  name: 'TeamPayment',
  components: {
    // CreditCard: () => import('@/components/CreditCard'),
  },
  props: ['id'],
  data() {
    return {
      pin,
      payment: {
        card: {},
        billingAddress: {}
      },
      registration: undefined,
      rules: {
        'billingAddress.addressLine1': defaultRequiredRule,
        'billingAddress.suburb': defaultRequiredRule,
        'billingAddress.state': +process.env.VUE_APP_NATIONAL_ID === 17 ? {} : defaultRequiredRule,
        'billingAddress.postcode': defaultRequiredRule,
        'billingAddress.country': defaultRequiredRule,
      },
      payToday: 0,
      key: 0,
      countryItems: [],
      countries,
      rego: {
        payAfterMeta: {
          amountPaid: 0,
          amountRemaining: 0,
          fullyPaid: false,
        },
        payAfter: true
      }
    };
  },
  async created() {
    console.log('reg', this.rego);
    // this.registration = this.rego;
    // this.$store.commit('loading', { loading: true, text: 'Loading...' });
    // this.$http.get('/assemble/api/v1/admin/payments/outstanding/team')
    //   .then((res) => {
    //     this.registration = res.data.data;
    //     this.$store.commit('loading', false);
    //   })
    //   .catch(() => {
    //     this.$message.error('Error loading team payment details');
    //     this.$store.commit('loading', false);
    //   });
    this.$store.commit('loading', { loading: true, text: 'Loading...' });
    const res = await this.$http.get(`/assemble/api/v1/portal/registrations/partial-payment/${this.id}`);
    // this.registration = res.data.data;
    this.rego = res.data.data;
    console.log({
      transactionFee: res.data.transactionFee,
    });
    this.$store.commit('cart/setTransactionFee', res.data.transactionFee);
    console.log('rego', this.rego);
    this.$store.commit('loading', false);
  },
  methods: {
    getAmountPaid(rego) {
      const { payAfterMeta, offlinePayments, } = rego;
      const amountPaidOffline = _.sumBy(offlinePayments, 'amount');
      return amountPaidOffline + payAfterMeta.amountPaid;
    },
    getTotal(rego) {
      const { payAfterMeta, offlinePayments } = rego;
      if (rego.productType === 'team') {
        return _.get(this.rego.pricing.event, 'total', 0);
      }
      const amountPaidOffline = _.sumBy(offlinePayments, 'amount');
      return amountPaidOffline + this.outstanding + payAfterMeta.amountPaid;
    },
    dateFormatter(r, c, v) {
      return v ? this.moment(v).format('YYYY-MM-DD HH:mm') : '';
    },
    priceFormatter(r, c, v) {
      return v ? `$${(v / 100).toFixed(2)}` : '';
    },
    parsePrice(val) {
      const rs = (val / 100).toFixed(2);
      if (val < 0) return `-$${(Math.abs(rs)).toFixed(2)}`;
      return `$${rs}`;
    },
    searchCountry(query) {
      if (query !== '') {
        setTimeout(() => {
          this.countryItems = this.countries.filter((item) => item.label.toLowerCase()
            .indexOf(query.toLowerCase()) > -1);
        }, 200);
      } else {
        this.countryItems = [];
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    submitPayment() {
      if (!this.payToday || this.payToday <= 0) {
        this.$message.error('Please enter an amount to pay');
        return;
      }

      Promise.all([this.$refs.card && this.$refs.card.validate(), this.$refs.form && this.$refs.form.validate()])
        .then(([cardValid, formValid]) => {
          if (this.requirePayment && (!cardValid || !formValid)) return;

          // issue card token
          const [expiryMonth, expiryYear] = this.payment.card.expiry.replace(/\s/g, '').split('/');

          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.pin.createCardToken({
            number: this.payment.card.number,
            name: this.payment.card.name,
            expiry_month: expiryMonth,
            expiry_year: expiryYear,
            cvc: this.payment.card.cvc,
            address_line1: this.payment.billingAddress.addressLine1,
            address_line2: this.payment.billingAddress.addressLine2 || '',
            address_city: this.payment.billingAddress.suburb,
            address_state: this.payment.billingAddress.state,
            address_postcode: this.payment.billingAddress.postcode,
            address_country: 'Australia',
          }).then((pinResponse) => {
            // Block International Cards
            // eslint-disable-next-line camelcase, no-unused-vars
            const { token, issuing_country, scheme } = pinResponse;
            // || !_.includes(['master', 'visa'], scheme)
            // eslint-disable-next-line camelcase
            if (!['AU', 'NZ'].includes(issuing_country) && [14, 18].includes(+process.env.VUE_APP_NATIONAL_ID)) {
              this.$store.commit('loading', false);
              this.$message.error('International cards are not supported.');
              return false;
            }
            if (!token) {
              this.$store.commit('loading', false);
              this.$message.error('There has been an error, try again later.');
            }
            // register with card token
            if (this.rego.productType === 'team') {
              this.payTeam(token);
            } else {
              this.pay(token);
            }
          }).catch((err) => {
            this.$store.commit('loading', false);
            const pinError = _.get(err, 'error_description');
            this.$message.error(pinError || 'There has been an error');
          });
        }).catch(() => {});
    },
    pay(token) {
      if (!token) return false;
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      return this.$http.post('/assemble/api/v1/portal/registrations/partial-payment', {
        cardToken: token,
        paymentTotal: this.payTodayTotal,
        paymentInstallment: this.payToday,
        registration: this.rego,
      }).then((res) => {
        this.$message.success('Payment Successful');
        this.$set(this, 'registration', res.data.data);
        this.payToday = this.outstanding;
        this.key++;
        this.$store.commit('loading', false);
        // return to dashboard
        const pathName = this.hasCustomEntity ? 'custom-dashboard' : 'dashboard';
        this.$router.push({ name: pathName });
      }).catch((err) => {
        const serverError = _.get(err, 'response.data.message');
        this.$store.commit('loading', false);
        this.$message.error(serverError || 'There has been an error');
      });
    },
    payTeam(token) {
      if (!token) return false;
      this.$store.commit('loading', true);
      return this.$http.post('/assemble/api/v1/portal/payments/outstanding/team', {
        cardToken: token,
        paymentTotal: this.payTodayTotal,
        paymentInstallment: this.payToday,
        eventId: this.rego.entityId,
        teamId: this.rego.teamId,
      }).then(() => {
        this.$message.success('Payment Successful');
        const pathName = this.hasCustomEntity ? 'custom-dashboard' : 'dashboard';
        this.$router.push({ name: pathName });
        this.$store.commit('loading', false);
      }).catch((err) => {
        const serverError = _.get(err, 'response.data.message');
        this.$store.commit('loading', false);
        this.$message.error(serverError || 'There has been an error');
      });
    },
    getSummaries() {
      return [`Total: $${(this.amountPaid / 100)}`];
    },
  },
  computed: {
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    getPercentage() {
      const { payAfterMeta, productType } = this.rego;
      if (productType === 'team') {
        return `${this.parsePrice(this.amountPaid)} / ${this.parsePrice(this.totalPrice)}`;
      }
      if (payAfterMeta) {
        const { amountPaid, amountRemaining } = payAfterMeta;
        return `${this.parsePrice(amountPaid)} / ${this.parsePrice(amountRemaining + amountPaid)}`;
      }
      return '0';
    },
    transactionFee() {
      let defaultFee = +this.$store.getters['cart/transactionFee'];
      if (!defaultFee) {
        const nationalMeta = this.$store.getters['national/getMeta'];
        if (nationalMeta && nationalMeta.transactionFee) {
          defaultFee = +nationalMeta.transactionFee;
        }
      }
      return defaultFee;
    },
    totalPrice() {
      const { rego } = this;
      if (rego && rego.productType === 'team') {
        return _.get(rego.pricing.event, 'total', 0);
      }
      if (rego && rego.payAfterMeta) {
        return rego.payAfterMeta.amountPaid + rego.payAfterMeta.amountRemaining;
      }
      return 0;
    },
    amountPaidWithFee() {
      if (this.registration && this.registration.payments) {
        return _.sumBy(this.registration.payments, 'amount');
      }
      return 0;
    },
    amountPaid() {
      const { rego } = this;
      if (rego && rego.productType === 'team') {
        const { payments } = rego;
        // sum all payments by amount-transactionFee
        return _.sumBy(payments, (p) => p.amount - p.transactionFee);
      }
      if (rego && rego.payAfterMeta) {
        return this.getAmountPaid(rego);
      }
      return 0;
    },
    outstanding() {
      const { payAfterMeta, productType, offlinePayments } = this.rego;
      let amountPaidOffline = 0;
      if (offlinePayments) {
        amountPaidOffline = _.sumBy(offlinePayments, 'amount');
      }

      if (productType === 'team') {
        console.log('this.rego', this.rego);
        return _.get(this.rego.pricing.event, 'total', 0) - this.amountPaid - amountPaidOffline;
      }
      if (payAfterMeta.amountRemaining > 0) {
        return payAfterMeta.amountRemaining - amountPaidOffline;
      }
      return 0;
    },
    minPayment() {
      const { outstanding } = this;
      return outstanding > 100 ? 100 : outstanding;
    },
    payTodayTotal() {
      const { payToday } = this;
      console.log('payToday', payToday);
      console.log('transactionFee', this.transactionFee);
      return +(payToday + ((payToday * this.transactionFee) / 100)).toFixed() || 0;
    },
    paymentPercentage() {
      const {
        registration, totalPrice, amountPaid, rego
      } = this;
      console.log(registration, totalPrice, amountPaid);
      if (registration || rego) {
        const total = this.getTotal(rego);
        return +((amountPaid / total) * 100).toFixed(0);
      }
      return 0;
    },
  },
  watch: {
    outstanding(val) {
      this.payToday = val;
      this.key++;
    }
  }
};
</script>
<style lang="scss" scoped>

.price-divider {
  padding: 0 0.5rem;
}

.box {
//   box-shadow: $boxShadow;
//   border-radius: $borderRadius;
}

.highlight {
//   background-color: $highlight;
}
.responsive-card-body {
  .payment-info {
      padding-left: 20px;
    }
    .general-info {
      padding-right: 20px;
    }

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    .info-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
    }
    .payment-info {
      padding-left: 0;
    }
    .general-info {
      padding-right: 0;
    }

  }
  @media (min-width: 500px) and (max-width: 768px) {
    flex-direction: column;
    .info-container {
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
    }
    .progress-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      margin-top: 20px;
    }
  }
  @media (min-width: 768px) {
    flex-direction: row;
    .info-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex: 3;
    }
    .progress-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      margin-top: 0;
    }
  }
}

.permission-card {
  margin: 10px 0 !important;
  padding: 10px;
  line-height: 40px;
  // border: $border;
//   border-radius: $borderRadius;
//   box-shadow: $boxShadow;
}

.detail{
    // font-family:  $fontLight;
    font-size: 15px;
}

.row-detail >
  .el-col {
  padding: 5px;
}
::v-deep .el-progress__text {
//   font-family: $fontLight;
  font-size: 14px !important;
}

.general-info,
.payment-info {
  display: flex;
  flex-direction: column;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
}

.label {
  font-weight: bold;
  color: #333;
  margin-right: 10px;
}

.value {
  color: #555;
}

.progress-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.info-card {
  width: 100%;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.info-item:last-child {
  margin-bottom: 0;
}
.payment-section, .billing-section {
    background-color: #fff;
    margin-bottom: 20px;
    h2 {
      color: #333;
      font-weight: bold;
      margin-bottom: 15px;
      margin-top: 0px;
    }
    .input-with-prefix {
      .el-input__inner {
        padding-left: 35px;
      }
      .dollar-sign {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        color: #333;
        font-weight: bold;
      }
    }
    .pay-today {
      font-size: 16px;
      margin-top: 1rem;
      margin-bottom: 1rem;
      strong {
        color: #4CAF50;
        font-weight: bold;
      }
    }
    .transaction-fee {
      color: #999;
      font-size: 14px;
      margin-bottom: 20px;
    }
    .credit-card-section {
      margin-top: 20px;
    }
  }
  .billing-section {
    h2 {
      margin-top: 0;
    }
  }
  .make-payment-btn {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
</style>
